<template>
  <input
    :placeholder="placeholder"
    :value="value"
    @input="$emit('input', $event.target.value)"
    class="search"
  />
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: { type: String, default: '検索' }
  }
}
</script>

<style>
.search { width: 100%; padding: 10px 12px; border: 1px solid #ccc; border-radius: 10px; margin: 8px 0 16px; font-size: 16px; }
</style>
